<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.87 17">
    <defs></defs>
    <g>
      <g>
        <polygon
          :class="getClassName"
          points="8.94 0 11.05 6.49 17.88 6.49 12.35 10.51 14.46 17 8.94 12.99 3.41 17 5.52 10.51 0 6.49 6.83 6.49 8.94 0"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    getClassName() {
      return ['star', this.active ? 'star--active' : null];
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../_sass/variables';
.star {
  fill: #d0d0d0;
  &--active {
    fill: $color__active;
  }
}
</style>
